var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0026 0C8.95562 0 0 8.95562 0 20.0026C0 31.0444 8.95562 40 20.0026 40C31.0444 40 40 31.0444 40 20.0026C40 8.95562 31.0444 0 20.0026 0ZM29.7326 28.4578C29.7326 29.0478 29.4429 29.6752 28.8582 29.6752H23.9378V22.3H26.4401L26.8194 19.1392H23.9378V17.2527C23.9378 16.4099 24.1644 15.9784 25.376 15.9784H27.0986V13.2227C26.5718 13.1858 25.7553 13.1068 24.6859 13.1068C22.4628 13.1068 20.777 14.466 20.777 16.963V19.1392H18.143V22.3H20.777V29.6752H11.6528C11.0628 29.6752 10.7678 29.0478 10.7678 28.4578V11.2525C10.7678 10.6625 11.0628 10.1836 11.6528 10.1836H28.8582C29.4429 10.1836 29.7326 10.6625 29.7326 11.2525V28.4578Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;